import { useState } from "react";
import { api } from "../../../../../../../../../utility/api";
import { descargarReporteExcel } from "../../../../../helpers/descargarReporteExcel";

export const TancadasTurnoApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTancadasTurno = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("tancadas/del_turno", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const descargarTancadasTurnoExcel = async (params) => {
        try {
            setCargando(true);
            await descargarReporteExcel(
                "tancadas/del_turno_excel",
                params,
                "tancadas_del_turno.xlsx",
            );
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTancadasTurno,
        descargarTancadasTurnoExcel,

        cargando,
    };
};
